import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGymnasticsAcrobaticHanging1 = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Regular",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "gymnastics-acrobatic-hanging-1" }),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 2.25,
			y1: 23.25,
			x2: 2.25,
			y2: .75
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 21.75,
			y1: 23.25,
			x2: 21.75,
			y2: .75
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 21.75,
			y1: 3,
			x2: 2.25,
			y2: 3
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 8.25,
			y1: 3,
			x2: 8.25,
			y2: 9.75
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "cls-1",
			cx: 8.25,
			cy: 12,
			r: 2.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 15.75,
			y1: 3,
			x2: 15.75,
			y2: 9.75
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "cls-1",
			cx: 15.75,
			cy: 12,
			r: 2.25
		})
	]
});
export default SvgGymnasticsAcrobaticHanging1;
